/* unplugin-vue-components disabled */import { render } from "./chat-v2.vue?vue&type=template&id=59adacc9&scoped=true"
import script from "./chat-v2.vue?vue&type=script&lang=js"
export * from "./chat-v2.vue?vue&type=script&lang=js"

import "./chat-v2.vue?vue&type=style&index=0&id=59adacc9&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59adacc9"],['__file',"src/pages/chats/chat-v2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59adacc9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59adacc9', __exports__)) {
    api.reload('59adacc9', __exports__)
  }
  
  module.hot.accept("./chat-v2.vue?vue&type=template&id=59adacc9&scoped=true", () => {
    api.rerender('59adacc9', render)
  })

}


export default __exports__